var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import React, { useState, useEffect, useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from "react-redux";
import { veteranUpdate, ShowButtons } from "../store/actions";
import imgYes from '../assets/yes_check.png';
import imgNo from '../assets/no_slash.png';

import { UserSession } from 'usersession';

var scrollToRef = function scrollToRef(ref) {
    return window.scrollTo(0, ref.current.offsetTop, { behavior: 'smooth' });
};
// General scroll to element function

export default function VARatesPoints() {
    var userSession = new UserSession();

    var _useState = useState(),
        _useState2 = _slicedToArray(_useState, 2),
        va = _useState2[0],
        setVa = _useState2[1];

    var dispatch = useDispatch();
    var vaRedux = useSelector(function (state) {
        return state.nameReducer.veteran;
    });

    var myRefVA = useRef(null);

    useEffect(function () {
        //This function scroll the slider into view
        !localStorage.getItem('doNotScroll') && scrollToRef(myRefVA);
    }, []);

    useEffect(function () {
        dispatch(ShowButtons(false));

        setVa(vaRedux);

        userSession.setVeteran(vaRedux);

        if (va) dispatch(ShowButtons(true));
    }, [va]);

    return React.createElement(
        React.Fragment,
        null,
        React.createElement(
            Form.Group,
            { className: 'mb-0' },
            React.createElement(
                Form.Row,
                { className: 'd-flex justify-content-center pt-1' },
                React.createElement(
                    Col,
                    { lg: 12, className: 'text-center mb-4' },
                    React.createElement(
                        'h2',
                        null,
                        'Are you a Veteran?'
                    )
                ),
                React.createElement(
                    Col,
                    { ref: myRefVA, lg: 3, className: 'mb-4' },
                    React.createElement(
                        'div',
                        { className: 'overlay' },
                        React.createElement(Form.Check, {
                            type: 'radio',
                            inline: true,
                            id: 'vaYes',
                            value: 'true',
                            label: 'Yes',
                            checked: va === "true",
                            onChange: function onChange(e) {
                                setVa(e.target.value);
                                dispatch(veteranUpdate(e.target.value));
                            } }),
                        React.createElement(Image, { src: imgYes,
                            alt: 'Yes checkmark',
                            className: 'radImg2 rounded-circle radImg customShadow \n                                ' + (va === "true" ? "d-none" : "") })
                    ),
                    React.createElement(
                        'h4',
                        null,
                        'Yes'
                    )
                ),
                React.createElement(
                    Col,
                    { lg: 3, className: 'mb-2' },
                    React.createElement(
                        'div',
                        { className: 'overlay' },
                        React.createElement(Form.Check, {
                            type: 'radio',
                            inline: true,
                            id: 'vaNo',
                            value: 'false',
                            label: 'No',
                            checked: va === "false",
                            onChange: function onChange(e) {
                                setVa(e.target.value);
                                dispatch(veteranUpdate(e.target.value));
                            } }),
                        React.createElement('img', { src: imgNo, alt: 'No checkmark',
                            className: 'radImg2 rounded-circle radImg customShadow ' + (va === "false" ? "d-none" : "") })
                    ),
                    React.createElement(
                        'h4',
                        null,
                        'No'
                    )
                )
            )
        )
    );
}